export default {
  title: 'ポイント商品',
  addGift: 'ギフトを追加',
  giftInfo: 'ギフト情報',
  giftInfoPlaceholder: 'キーワードで検索してください',
  category: 'カテゴリ',
  publishStatus: '状態',
  batchSetStock: '在庫を一括設定',
  batchOnline: '一括公開',
  batchOffline: '一括非公開',
  batchOnlineConfirm: '商品を一括公開してもよろしいですか？',
  batchOfflineConfirm: '商品を一括非公開にしてもよろしいですか？',
  batchSetStockTitle: '在庫を一括設定',
  batchSetStockPlaceholder: '在庫数量を入力してください',
  batchSetStockTip: '選択した {count} 個のギフトに在庫を一括設定します',
  selectFirstTip: 'まず商品を選択してください',
  exchangePrice: '交換価格',
  exchangedQty: '交換済み数量',
  stock: '在庫',
  status: '状態',
  online: '公開済み',
  offline: '非公開',
  createTime: '作成時間',
  edit: '編集',
  delete: '削除',
  deleteConfirm: '削除後は元に戻せません。削除してもよろしいですか？',
  editStock: '在庫を編集',
  stockRequired: '在庫数量を入力してください',
  stepSelectGift: 'ギフトを選択',
  stepGiftConfig: 'ギフト設定',
  addGiftTitle: 'ギフトを追加',
  editGiftTitle: 'ギフトを編集',
  giftLibCategory: 'ギフトライブラリカテゴリ',
  pricePerYuan: '価格/元',
  giftType: 'ギフトタイプ',
  giftTypeAll: 'すべて',
  giftTypePhysical: '物理ギフト',
  giftTypeVirtual: '仮想ギフト',
  stockCount: '在庫数',
  selectAction: '選択',
  giftSnLabel: '番号',
  giftNo: 'ギフト番号',
  selectedGift: '選択済みギフト',
  marketPrice: '市場価格',
  exchangePriceLabel: '交換可能価格',
  pointsPay: 'ポイント支払い',
  exchangeQty: '交換可能数量',
  specInfo: '仕様情報',
  specStock: '仕様在庫',
  exchangePriceCol: '交換価格',
  pointsUnit: 'ポイント',
  inputPlaceholder: '入力してください',
  virtualExchange: '仮想交換量',
  virtualExchangePlaceholder: '仮想交換量を入力してください',
  listSort: 'リストソート',
  listSortPlaceholder: '入力してください',
  publish: 'すぐに公開',
  categoryRequired: 'カテゴリを選択してください',
  exchangePriceRequired: '交換可能価格を選択してください',
  specStockRequired: '仕様在庫を記入してください',
  specPriceRequired: '交換価格を記入してください',
};
